import { Link } from "react-router-dom";
import { SERVER_IP, DISCORD_URL } from "@/lib/api";
import { Youtube, Instagram, Twitter, MessageCircle } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="relative z-10 mt-32 border-t border-white/10 bg-black" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <Logo className="h-12 mb-4" />
          <p className="text-sm text-white/60 leading-relaxed">
            India's ultimate Lifesteal SMP community. Fair-play, custom mechanics, weekly events and a passionate crew.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#FFBF00] mb-4">Network</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/servers" className="hover:text-[#FFBF00]">Servers</Link></li>
            <li><Link to="/leaderboards" className="hover:text-[#FFBF00]">Leaderboards</Link></li>
            <li><Link to="/events" className="hover:text-[#FFBF00]">Events</Link></li>
            <li><Link to="/builds" className="hover:text-[#FFBF00]">Builds Gallery</Link></li>
            <li><Link to="/store" className="hover:text-[#FFBF00]">Store</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#FFBF00] mb-4">Community</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-[#FFBF00]">About Us</Link></li>
            <li><Link to="/rules" className="hover:text-[#FFBF00]">Rules</Link></li>
            <li><Link to="/contact" className="hover:text-[#FFBF00]">Contact</Link></li>
            <li>
              <a data-testid="footer-discord" href={DISCORD_URL} target="_blank" rel="noreferrer" className="hover:text-[#FFBF00]">
                Discord
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#FFBF00] mb-4">Play Now</div>
          <div className="rounded-lg glass p-4">
            <div className="text-[11px] uppercase tracking-widest text-white/50">Java IP</div>
            <div className="font-mono text-[#FFBF00] text-lg">{SERVER_IP}</div>
            <div className="text-[11px] uppercase tracking-widest text-white/50 mt-3">Version</div>
            <div className="font-mono text-sm">1.20.x — 1.21.x</div>
          </div>
          <div className="flex items-center gap-3 mt-4 text-white/70">
            <a href="#" data-testid="social-youtube" aria-label="YouTube" className="hover:text-[#FFBF00]"><Youtube size={18} /></a>
            <a href="#" data-testid="social-instagram" aria-label="Instagram" className="hover:text-[#FFBF00]"><Instagram size={18} /></a>
            <a href="#" data-testid="social-twitter" aria-label="Twitter" className="hover:text-[#FFBF00]"><Twitter size={18} /></a>
            <a href={DISCORD_URL} data-testid="social-discord" aria-label="Discord" className="hover:text-[#FFBF00]"><MessageCircle size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t-2 border-[#FFBF00]/30">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© 2026 <span className="text-[#FFBF00] font-semibold">LostDC Network</span>. Not affiliated with Mojang Studios.</div>
          <div className="font-hero text-sm text-white/70">
            LostDC Network <span className="text-white/40 mx-2">·</span> <span className="text-[#FFBF00]">powered by LostDRKC</span>
          </div>
          <div className="font-mono uppercase tracking-widest">Built for the community · Made in India</div>
        </div>
      </div>
    </footer>
  );
}
